export default __webpack_public_path__ + "static/logo-70c968991e1276d8f55e6c6769d7d23c.svg";